// extracted by mini-css-extract-plugin
export default {"dealInfo":"DealInfo_dealInfo__pv1LG","header":"DealInfo_header__af7TF","top":"DealInfo_top__DrzPq","total":"DealInfo_total__GttjY"};